import React from 'react'
import { ActivityIndicator, StyleSheet, View } from 'react-native'
import { AppModal as Modal } from '../atoms/AppModal'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'

export const LoadingView = ({ isLoading }: { isLoading: boolean }): React.ReactElement => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <Modal visible={isLoading} transparent animationType="fade">
      <View style={styles.container}>
        <View style={styles.backdrop} />
        <ActivityIndicator size="large" color={theme.colors.primary} />
      </View>
    </Modal>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      ...StyleSheet.absoluteFillObject,
      alignItems: 'center',
      justifyContent: 'center',
    },
    backdrop: {
      backgroundColor: theme.colors.black,
      opacity: 0.6,
      ...StyleSheet.absoluteFillObject,
    },
  })
